export default "__VITE_ASSET__NfAEFeUl__"